import React from 'react';

import cs from 'classnames';

import Typography from '../Typography/Typography';

const Header = ({
  title,
  subtitle,
  onBadgeClick = null,
  children,
  className,
  compact = false,
  titleClassName,
  titleAddon,
  childrenClassName,
  // The children become the row's own flex items, so a group that doesn't fit wraps under the
  // title. Each child sizes itself: views `flex-1 basis-0`, actions `ml-auto`.
  wrap = false
}) => (
  <div
    className={cs(
      'relative z-10 flex justify-between gap-2 border-0 !border-b !border-solid !border-neutral-100 bg-white !px-4 py-2',
      compact && !wrap && 'h-10 items-center !py-0',
      // No vertical padding: view tabs fill the row so their underline lands on its bottom border.
      wrap && 'min-h-10 flex-wrap items-center gap-y-1 !py-0',
      className
    )}>
    <div className={cs('flex items-center gap-1', !title && !subtitle && 'hidden')}>
      {title && (
        <Typography
          variant="p"
          size="medium"
          weight="medium"
          className={cs(
            'w-max first-letter:uppercase',
            wrap && '!text-sm !font-600 !text-neutral-900',
            titleClassName
          )}>
          {title}
        </Typography>
      )}
      {title && titleAddon}
      {subtitle && (
        <div
          className={cs(
            'flex items-center justify-center rounded-full bg-primary-50 !py-1 px-[10px]',
            !!onBadgeClick && 'cursor-pointer'
          )}
          onClick={onBadgeClick}>
          <span className="w-max text-base font-500 capitalize leading-6 text-primary-600">
            {subtitle}
          </span>
        </div>
      )}
    </div>
    {wrap ? (
      children
    ) : (
      <div className={cs('flex flex-1 justify-end gap-2', childrenClassName)}>{children}</div>
    )}
  </div>
);

export default Header;
